import './AddressCompact.scss';
import Component from './AddressCompact.js';
export default Component;
